import { render } from "./AdButton.vue?vue&type=template&id=22c6a436&scoped=true"
import script from "./AdButton.vue?vue&type=script&lang=js"
export * from "./AdButton.vue?vue&type=script&lang=js"

import "./AdButton.vue?vue&type=style&index=0&id=22c6a436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c6a436"]])

export default __exports__